export { interpolateColor, interpolatePureColorArrayToStr } from './color-string';
export { pointInterpolation, pointsInterpolation } from './common/utils';
